import React from "react";
import { Title, Space, Text } from "@mantine/core";
import logo from "../../../assets/logo-icon.png";
const LoaderComponent = ({ loading, overlayLoading }) => {
  return (
    <div
      className={
        overlayLoading
          ? "loader_container transparent-loader"
          : "loader_container"
      }
    >
      <img
        alt="Rotation Icon"
        className="rotate-Icon"
        src={logo}
        draggable="false"
        height={100}
      />
      {!overlayLoading ? (
        <>
          <Space h={50}></Space>
          <Title>Play Safely</Title>
          <Text>Loading..</Text>
        </>
      ) : null}
    </div>
  );
};

export default LoaderComponent;
